var map = {
	"./8887a58d-32b9-40e3-aa41-115f43839e58.jpg": 1729,
	"./PXL_20260504_040425327.MP.jpg": 692,
	"./PXL_20260504_043423460.MP.jpg": 3951,
	"./PXL_20260504_043440947.MP.jpg": 1292,
	"./PXL_20260504_043452389.jpg": 6636,
	"./PXL_20260504_043913391.jpg": 2379,
	"./PXL_20260504_044011096.jpg": 1873,
	"./PXL_20260504_044336182.jpg": 4089,
	"./PXL_20260504_044954324.MP.jpg": 8000,
	"./PXL_20260504_045139315.jpg": 4417,
	"./PXL_20260504_045702900.MP.jpg": 9528,
	"./PXL_20260504_050606761.MP.jpg": 6460,
	"./PXL_20260504_052428057.jpg": 2037,
	"./vlcsnap-2026-05-04-13h50m29s87.jpg": 3040,
	"./vlcsnap-2026-05-04-13h51m19s59.png": 5275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5588;